<template>
  <div class="contract_container">
    <!-- <div class="contract_head_container">
      <h4>Contrat</h4>
    </div> -->
    <!-- <div class="contract_body_container"> -->
      <offer :offer="contract.offer">
        <slot name="contract_option">
        </slot>
      </offer>
      <div class="subline">
        <order :order="contract.order">
        </order>
        <agency :agency="contract.offer.distributed_product.agency"></agency>
      </div>
    <!-- </div> -->
  </div>
</template>
<script>
import Offer from "./Contract/Offer"
import Order from "./Contract/Order"
import Agency from "./Contract/Agency"

export default {
  props:["contract"],
  components:{
    Offer,
    Order,
    Agency,
  },
}
</script>
<style scoped>

.contract_container {
  /*display: inline-flex;*/
  background-color: white;
  /*width: -webkit-fill-available;*/
  /*min-width: 350px;*/
}

.contract_head_container {
  border-bottom:solid 1px lightgrey;
}

.subline {
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}

@media screen and (max-width:1200px) {
  .subline {
    display: block;
  }

}

</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/Contract.vue